(function () {
    'use strict';

    angular
        .module('app.memberAdmin')
        .constant('memberRolesResolver', {
            individualId: create('individualId'),
            roles: create('roles'),
            roleList: create('roleList'),
            createRole: create('createRole')
        });

    var copy = angular.copy;

    function create(property) {
        getData.$inject = ['$q', '$transition$', 'Member', 'Role'];
        return getData;

        function getData($q, $transition$, Member, Role) {
            var individualId = $transition$.params().individualId;
            if (!$transition$.resolvePromise) {
                $transition$.resolvePromise = $q.all({
                    individualId: $q.resolve(individualId),
                    roles: Member.getRoles({ id: individualId }, true).$promise,
                    roleList: Role.getAll(true).$promise,
                    createRole: RoleWrapper
                });
            }
            return $transition$.resolvePromise.then(getter);
            function getter(data) {
                if (property !== 'roles')
                    return data[property];

                RoleWrapper.roleMapping = data.roleList.reduce(reduce, {});
                return data.roles.map(RoleWrapper);

                function reduce(acc, curr) {
                    return (acc[curr.id] = curr.name) && acc || acc;
                }
            }
        }
    }

    var RoleWrapper = (function () {
        function Role(data) {
            var that = this;
            if (!(this instanceof Role))
                return new Role(data);

            Object.defineProperties(this, {
                _data: { writable: true, value: data },
                _pristine: { writable: true, value: data },
                domain: { get: get('domain'), set: set('domain'), enumerable: true },
                individualId: { get: get('individualId'), set: set('individualId'), enumerable: true },
                oldDomain: { get: get('oldDomain'), set: set('oldDomain'), enumerable: true },
                oldRoleId: { get: get('oldRoleId'), set: set('oldRoleId'), enumerable: true },
                roleId: { get: get('roleId'), set: set('roleId'), enumerable: true },
                roleName: { get: get('roleName'), set: set('roleName'), enumerable: true },
                description: { get: get('description'), set: set('description'), enumerable: true },
                isEditing: { get: function () { return this._data !== this._pristine; } }
            });

            function get(name) {
                return that.$get.bind(that, name);
            }
            function set(name) {
                return that.$set.bind(that, name);
            }
        }
        Role.prototype = {
            $get: function $get(name) { return this._data[name]; },
            $set: function $set(name, value) {
                this._data[name] = value;
                if (name == 'roleId')
                    this._data.roleName = RoleWrapper.roleMapping[value];
            },
            $edit: function $edit() { this._data = copy(this._pristine); },
            $rollback: function $rollback() { this._data = this._pristine; },
            $commit: function $commit(data) { this._data = copy(data || this._data, this._pristine); }
        };
        return Role;
    })();

})();